import { actions } from '../../../utils/constants';

const INITIAL_STATE = {
  rank: [],
  loading: false
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case actions.FETCH_RANK_START:
      return { ...state, loading: true  };

    case actions.FETCH_RANK_FINISH:
      return { ...state, rank: [...payload ] , loading: false  };

    case actions.FETCH_RANK_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/containers/ranking/ranking.reducer.js